// Backend `field` value on CreateAccountDepotPayload.errors for a duplicate
// primary-contact email. Confirmed against the API: returns exactly
// `{ field: "primaryContact.email", code: "taken", ... }`.
export const PRIMARY_CONTACT_EMAIL_ERROR_FIELD = 'primaryContact.email';
